<template>
    <div class="btn-group dropup container-fluid cta-dropup-select">
      <button type="button" class="dropdown-toggle cta-form-control" :data-testid="testid"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div><i v-if="icon" :class="currentValue.icon_class"></i>{{ currentValue.text }}</div>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <div class="dropdown-item" v-for="opt in options" v-bind:key="opt.value"
          @click="updateSelected(opt.value)"
          :value="opt.value" :data-testid="opt.testid">
          <i v-if="icon" :class="opt.icon_class"></i>
          {{ opt.text }}
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    initial_value: String,
    field_name: String,
    options: Array,
    icon: Boolean,
    testid: String
  },
  data: function() {
    return {
      value: null
    }
  },
  created() {
    this.value = this.initial_value || this.options[0];
  },
  methods: {
    updateSelected: function(selection) {
      this.value = selection;
      this.$emit(`update:${this.field_name}`, selection);
    }
  },
  computed: {
    currentValue: function() {
      return (this.selectedValue || this.options[0]);
    },
    selectedValue: function() {
      for (const o of this.options) {
        if (o.value === this.value) return o;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "application.scss";

.cta-form-control {
  border: 1px solid #e9ecef !important;
  text-shadow: none;
  box-shadow: none;
  background-color: $white;
  width: 100%;
  height: $cta-form-control-height;
  border: none;
  padding: 0 15px;
  border-radius: 5px;
  font-weight: 300;
  font-size: 16px;
  -webkit-transition: .4s;
  transition: .4s;

  &:focus {
    box-shadow: unset;
    padding-left: 20px;
  }
}

.cta-dropup-select {
  button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'SFpro';

    div {
      display: flex;
      align-items: center;
    }
  }
  .dropdown-item {
    display: flex;
    align-items: center;
    color: $bright-blue;
    cursor: pointer;
  }
}

.custom-control-button {
  &:focus {
    outline-style: none;
  }
}

.cta-square-icon {
  content: url('@img/icons-square-corners.svg');
  margin-right: 5px;
}
.cta-slightly-rounded-icon {
  content: url('@img/icons-slightly-rounded-corners.svg');
  margin-right: 5px;
}
.cta-rounded-icon {
  content: url('@img/icons-rounded-corners.svg');
  margin-right: 5px;
}
</style>
